export const defaultPlaceholders = {
  name: 'Enter your name',
  email: 'Enter your email',
  message: 'Enter your message'
}
